import { RowInfo } from '../models/row-info';
import { RowId } from './row-id-enum';

export const cRows = (): RowInfo[][] => [
  c1Rows(),
  c2Rows(),
  c3Rows(),
  c4Rows(),
  c5Rows(),
  c6Rows(),
];

const c1Rows = (): RowInfo[] => [
  {
    description: 'Debito finanziario lordo/EBITDA',
    id: RowId.debitoFinanziarioLordoEbitda,
    options: [
      { view: 'inferiore a 5', value: 5 },
      { view: '5', value: 4 },
      { view: 'tra 5 e 8.5', value: 3 },
      { view: 'tra 8.5 e 14.5', value: 2 },
      { view: 'tra 14.5 e 19', value: 1 },
      { view: 'superiore a 19 o EBITDA negativo', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 20,
  },
  {
    description: 'Loan To Value',
    id: RowId.loanToValue,
    options: [
      { view: 'inferiore a 20%', value: 5 },
      { view: 'tra 20% e 40%', value: 4 },
      { view: 'tra 40% e 60%', value: 3 },
      { view: 'tra 60% e 85%', value: 2 },
      { view: 'superiore a 85%', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 5,
  },
  {
    description: 'EBITDA/Oneri finanzari',
    id: RowId.ebitdaOneriFinanzari,
    options: [
      { view: 'superiore a 7', value: 5 },
      { view: 'tra 4 e 7', value: 4 },
      { view: 'tra 2 e 4', value: 3 },
      { view: 'tra 0 e 2', value: 2 },
      { view: 'EBITDA negativo', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 15,
  },
  {
    description: 'PFN/Equity',
    id: RowId.pfnEquity,
    options: [
      { view: 'inferiore a 1', value: 5 },
      { view: 'tra 1 e 4', value: 4 },
      { view: 'tra 4 e 6.5', value: 3 },
      { view: 'tra 6.5 e 9', value: 2 },
      { view: 'superiore a 9 o Equity negativo', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 10,
  },
  {
    description: 'Cassa/Debito totale a breve termine',
    id: RowId.cassaDebitoTotaleABreveTermine,
    options: [
      { view: 'superiore a 16%', value: 5 },
      { view: 'tra 8% e 16%', value: 4 },
      { view: 'tra 4% e 8%', value: 3 },
      { view: 'tra 1% e 4%', value: 2 },
      { view: 'inferiore a 1%', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 25,
  },
  {
    description:
      'Debt Service Coverage Ratio (da valorizzare solo in presenza di budget)',
    id: RowId.debtServiceCoverageRatioDaValorizzareSoloInPresenzaDiBudget,

    options: [
      { view: 'superiore o pari a 2.5', value: 5 },
      { view: 'tra 1.5 e 2.5', value: 4 },
      { view: 'tra 1 e 1.5', value: 3 },
      { view: 'tra 0.5 e 1', value: 2 },
      { view: 'inferiore a 0.5', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 10,
  },
  {
    description: 'EBITDA Margin',
    id: RowId.ebitdaMargin,
    options: [
      { view: 'superiore a 15%', value: 5 },
      { view: 'tra 7% e 15%', value: 4 },
      { view: 'tra 3% e 7%', value: 3 },
      { view: 'tra 0% e 3%', value: 2 },
      { view: 'inferiore a 0%', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 15,
  },
];

const c2Rows = (): RowInfo[] => [
  {
    description: 'Regolarità dei debiti tributari e previdenziali',
    id: RowId.regolaritaDeiDebitiTributariEPrevidenziali,
    options: [
      { view: 'inferiore al 2%', value: 5 },
      { view: 'tra 2% e 7%', value: 4 },
      { view: 'tra 7% e 12%', value: 3 },
      { view: 'tra 12% e 20%', value: 2 },
      { view: 'superiore al 20%*', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];

const c3Rows = (): RowInfo[] => [
  {
    description:
      'Analisi interna su fondatezza/sostenibilità delle ipotesi del piano e track record',
    id: RowId.analisiInternaSuFondatezzaSostenibilitaDelleIpotesiDelPianoETrackRecord,

    options: [
      { view: 'Overperforming', value: 5 },
      { view: 'Nessuno scostamento', value: 4 },
      { view: 'Lieve scostamento in negativo', value: 3 },
      { view: 'Apprezzabile scostamento in negativo', value: 2 },
      { view: 'Elevato scostamento in negativo', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];

const c4Rows = (): RowInfo[] => [
  {
    description:
      'Piano industriale asseverato da advisor industriali/finanziari esterni',
    id: RowId.pianoIndustrialeAsseveratoDaAdvisorIndustrialiFinanziariEsterni,
    options: [
      { view: "Presenza dell'opinion", value: 5 },
      { view: 'Assenza di opinion', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];

const c5Rows = (): RowInfo[] => [
  {
    description: 'Score settoriale',
    id: RowId.scoreSettoriale,
    options: [
      { view: 'Agricoltura', value: 2 },
      { view: 'Mining – Oil Gas', value: 2 },
      { view: 'Alimentare, Bevande e Tabacco', value: 2 },
      { view: 'Tessile e Abbigliamento', value: 1 },
      { view: 'Prodotti non metallici', value: 3 },
      { view: 'Prodotti Metallici', value: 3 },
      { view: 'Elettronica', value: 4 },
      { view: 'Meccanica e mezzi di trasporto', value: 3 },
      { view: 'Meccanica strumentale', value: 4 },
      { view: 'Chimica', value: 5 },
      { view: 'Farmaceutica', value: 5 },
      { view: 'Costruzioni', value: 1 },
      { view: 'Ingegneria Civile', value: 1 },
      { view: 'Impiantistica', value: 2 },
      { view: 'Immobiliare', value: 2 },
      { view: 'Commercio all’ingrosso', value: 3 },
      { view: 'Commercio al dettaglio', value: 2 },
      { view: 'Commercio di autoveicoli', value: 2 },
      { view: 'ICT, Media e TLC', value: 4 },
      { view: 'Utilities ed Energia', value: 3 },
      { view: 'Trasporti e Logistica', value: 1 },
      { view: 'Altri Servizi', value: 3 },
      { view: 'Consulenza e professionisti', value: 4 },
      { view: 'Servizi Socio Sanitari, Istruzione e PA', value: 3 },
      { view: 'Leisure', value: 1 },
    ],
    kriWeight: 33,
  },
  {
    description: 'Diversificazione geografica',
    id: RowId.diversificazioneGeografica,
    options: [
      {
        view: 'La società è ben diversificata su tutti o quasi i continenti e nessun mercato pesa per oltre il 20% in termini di fatturato e/o EBITDA.',
        value: 5,
      },
      {
        view: "L'operatività sul principale mercato è inferiore al 50% in termini di fatturato e/o EBITDA e/o la società non mostra fenomeni di concentrazione verso altri paesi.",
        value: 4,
      },
      {
        view: "L'operatività sul principale mercato è compresa nella fascia 50%-80% in termini di fatturato e/o EBITDA, mostrando tuttavia una buona diversificazione a livello internazionale.",
        value: 3,
      },
      {
        view: "Operatività prevalentemente sul mercato domestico (oltre l'80% in termini di fatturato e/o EBITDA) e/o estesa a tutto il territorio nazionale.",
        value: 2,
      },
      {
        view: 'Operatività limitata a poche regioni sul mercato domestico.',
        value: 1,
      },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 33,
  },
  {
    description: 'Diversificazione di business',
    id: RowId.diversificazioneDiBusiness,
    options: [
      {
        view: 'La società ha più linee di business con buona ripartizione di fatturato e/o margini operativi (nessuna oltre il 30%) e scarsa correlazione tra le varie linee e/o mercati di sbocco.',
        value: 5,
      },
      {
        view: 'La principale linea di business non contribuisce per oltre il 50% a fatturato e/o margini operativi e si rileva una scarsa correlazione tra le varie linee e/o mercati di sbocco.',
        value: 4,
      },
      {
        view: 'Il contributo della principale linea di business a fatturato e/o margini operativi è compreso nella fascia 50%-75%, mostrando tuttavia una buona diversificazione e/o scarsa correlazione tra le restanti linee di business.',
        value: 3,
      },
      {
        view: 'La linea di business principale contribuisce per oltre il 75% a fatturato e/o margini operativi.',
        value: 2,
      },
      {
        view: 'La linea di business principale contribuisce per oltre il 90% a fatturato e/o margini operativi.',
        value: 1,
      },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 33,
  },
];

const c6Rows = (): RowInfo[] => [
  {
    description: '',
    options: [
      {
        view: 'Pagamenti non regolari negli ultimi 12 mesi e/o aspettative di ritardi in un orizzonte di breve periodo',
        value: -1,
      },
      {
        view: 'Pagamenti regolari negli ultimi 12 mesi',
        value: 0,
      },
      {
        view: 'Pagamenti non ancora previsti',
        value: 0,
      },
    ],
    kriWeight: 100,
  },
];
